export default "/images/check-circle.svg?fc206c2b3a24c4ad59aca1c8267ee8d5";